// extracted by mini-css-extract-plugin
export var chip = "_4n-0";
export var filterDropdown = "_4n-5";
export var filterItem = "_4n-6";
export var icon = "_4n-1";
export var removeButton = "_4n-3";
export var removeIcon = "_4n-4";
export var separator = "_4n-2";